export function arrayToString(array: string[]): string {
    return array.length > 0 ? array.join(', ') : '*';
}